export const PERSONAL_EMAIL_DOMAINS = [
	'gmail.com',
	'yahoo.com',
	'live.com',
	'hotmail.com',
	'outlook.com',
	'icloud.com',
	'aol.com',
	'protonmail.com',
	'proton.me',
	'mail.com',
	'yandex.com',
	'zoho.com',
	'gmx.com',
	'rediffmail.com',
	'msn.com'
]

export const isWorkEmail = (email: string): boolean => {
	if (!email) return false
	const domain = email.split('@')[1]?.toLowerCase()
	if (!domain) return false
	return !PERSONAL_EMAIL_DOMAINS.includes(domain)
}

export const extractDomainFromEmail = (email: string): string => {
	if (!email) return ''
	const domain = email.split('@')[1]
	return domain || ''
}
